/* eslint-disable react/forbid-prop-types */
import cx from 'classnames';
import moment from 'moment-timezone';
import {useMemo} from 'react';
import PropTypes from 'prop-types';
import {DatePicker} from '~library/atoms/DatePicker';
import {Typography} from '~library/atoms/Typography';
import {formatDateShort} from '~/SignUpSheets/utils/misc';

import './DateField.sass';

export const DateField = ({
  onChange,
  schema,
  value,
  className,
  errors,
  disabled = false,
  'data-qa-id': dataQaId,
}) => {
  const defaultDate = useMemo(() => moment().format('MM/DD/YYYY'), []);
  const date = useMemo(() => (value ? moment(value) : null), [value]);

  return (
    <div className={cx({[className]: !!className})}>
      {disabled && date ? (
        <Typography variant="header5" data-qa-id={dataQaId}>
          {formatDateShort(date)}
        </Typography>
      ) : (
        <DatePicker
          value={date?.toISOString() ?? defaultDate}
          dateValueFormat="m/d/Y"
          dateRenderFormat="l, M j, Y"
          placeholder={
            date?.format('MM/DD/YYYY') || schema.placeholder || moment().format('MM/DD/YYYY')
          }
          inputContainerClassName="date-field__wrapper"
          className="item-field"
          onChange={(_, dateStr) => onChange(dateStr)}
          error={errors?.[0]?.msg}
          disabled={disabled}
          data-qa-id={dataQaId}
          variant="header5"
        />
      )}
    </div>
  );
};

DateField.propTypes = {
  onChange: PropTypes.func,
  schema: PropTypes.shape({
    mobile_display_name: PropTypes.string,
    display_name: PropTypes.string.isRequired,
    schema: PropTypes.bool,
    placeholder: PropTypes.string,
  }).isRequired,
  value: PropTypes.string,
  className: PropTypes.string,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      loc: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
      msg: PropTypes.string.isRequired,
    })
  ),
  disabled: PropTypes.bool,
  'data-qa-id': PropTypes.string.isRequired,
};
